import { moveApi } from '../services/moveApi'

export function mapTaskFromApi (task) {
  return {
    ...task,
    listId: task.list_id ?? task.listId,
    boardId: task.board_id ?? task.boardId,
    dueDate: task.due_date ?? task.dueDate,
    createdAt: task.created_at ?? task.createdAt,
    assignedTo: task.assigned_to ?? task.assignedTo ?? [],
    createdBy: task.created_by ?? task.createdBy,
    boardName: task.board_name ?? task.boardName,
    archived: Boolean(task.archived ?? task.archived_at ?? task.archivedAt),
    archivedAt: task.archived_at ?? task.archivedAt ?? null
  }
}

export function mapListFromApi (list) {
  return {
    ...list,
    boardId: list.board_id ?? list.boardId
  }
}

export function mapMemberFromApi (member) {
  const userId = member.user_id ?? member.uid
  return {
    uid: String(userId),
    user_id: userId,
    email: member.email,
    name: member.name,
    surname: member.surname,
    role: member.role,
    photoURL: member.avatar
  }
}

export function mapBoardFromApi (board, currentUserId) {
  return {
    ...board,
    owner: board.owner_id ?? board.owner,
    members: (board.members || []).map(mapMemberFromApi),
    is_owner: board.is_owner ?? board.owner_id === currentUserId
  }
}

export async function loadBoardPayload (boardId) {
  const { data } = await moveApi.getBoard(boardId)
  const payload = data.data

  return {
    board: payload.board,
    lists: (payload.lists || []).map(mapListFromApi),
    tasks: (payload.tasks || []).map(mapTaskFromApi),
    users: (payload.users || []).map((user) => ({
      uid: String(user.id),
      id: user.id,
      email: user.email,
      name: user.name,
      surname: user.surname,
      role: user.role,
      photoURL: user.avatar
    }))
  }
}

export default moveApi
